import { isWeb } from "../../../../utils/user-agent";
import { getDownloadLink } from "../../../../utils/app-download-link";
import { track } from "@amplitude/analytics-browser";

interface ReviewListCtaProps {
  onExplore: () => void;
}

export function ReviewListCta({ onExplore }: ReviewListCtaProps) {
  if (!isWeb()) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 p-4">
      <div className="flex gap-3">
        <button
          onClick={() => {
            window.open(getDownloadLink(), "_blank");
            track("앱 다운로드 클릭", { 어디서: "리뷰 전체보기" });
          }}
          className="flex-1 bg-gray-800 hover:bg-gray-900 text-white font-bold py-4 px-6 rounded-lg transition-colors duration-200"
        >
          앱 다운로드
        </button>
        <button
          onClick={onExplore}
          className="flex-1 bg-[#1562fc] text-white font-bold py-4 px-6 rounded-lg transition-colors duration-200 whitespace-nowrap"
        >
          다른 후기 구경하기
        </button>
      </div>
    </div>
  );
}
